import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import homeInsuranceService from "../../api/homeInsuranceService";
import apiClient from "../../api/config";
import HOMEINSURANCE_ENDPOINTS from "../../api/endpoints/homeInsuranceEndpoints";

export const createHomeInsurance = createAsyncThunk(
  "homeInsurance/createHomeInsurance",
  async (payload) => {
    try {
      const response = await homeInsuranceService.createHomeInsurance(payload);
      if (response) {
        return {
          HomeInsuranceItem: response?.data,
          actionFlag: "HOME_INSURANCE_CREATED",
          success: "",
          error: "",
        };
      }
    } catch (error) {
      return {
        HomeInsuranceItem: {},
        actionFlag: "HOME_INSURANCE_ERR",
        success: "",
        error: error,
      };
    }
  },
);
export const downloadHomePDF = createAsyncThunk(
  "pdf/download",
  async (data, { rejectWithValue }) => {
    try {
      const response = await apiClient.post(
        HOMEINSURANCE_ENDPOINTS.DownloadHomeInsurancePDF,
        data,
        { responseType: "blob" },
      );

      // Trigger download inside thunk
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Home_Insurance_Quote.pdf`;
      link.click();
      window.URL.revokeObjectURL(url);

      return { success: true };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Initial state
const initialState = {
  HomeInsuranceItem: {},
  actionFlag: "",
  isLoading: false,
  isSuccess: false,
  isError: false,
  errorMessage: "",
  successMessage: "",
};

const homeInsuranceSlice = createSlice({
  name: "homeInsurance",
  initialState,
  reducers: {
    // Reset state
    resetContactState: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.errorMessage = "";
      state.successMessage = "";
      state.actionFlag = "";
    },
    // Clear messages
    clearMessages: (state) => {
      state.successMessage = "";
      state.errorMessage = "";
      state.actionFlag = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createHomeInsurance.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(createHomeInsurance.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.successMessage = action.payload.message;
        state.HomeInsuranceItem = action.payload.HomeInsuranceItem || {};
        state.errorMessage = "";
        state.actionFlag = action.payload.actionFlag;
      })
      .addCase(createHomeInsurance.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
        state.successMessage = "";
      });
  },
});

export const { resetContactState, clearMessages } = homeInsuranceSlice.actions;
export default homeInsuranceSlice.reducer;
